export default __webpack_public_path__ + "media/color/ryo-40018dbd.svg";